'use strict'

var __assign = function () {
    __assign = Object.assign || function __assign (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i]
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
        }
        return t
    }
    return __assign.apply(this, arguments)
}

function clearNode (node) {
    while (node.firstChild) { node.removeChild(node.firstChild) }
}
function getEventTarget (event) {
    try {
        if (typeof event.composedPath === 'function') {
            var path = event.composedPath()
            return path[0]
        }
        return event.target
    } catch (error) {
        return event.target
    }
}

var defaultConfig = {
    shorthand: false,
    dateFormat: 'Y',
    altFormat: 'Y',
    ariaDateFormat: 'Y',
    theme: 'light',
    currentRange: [new Date().getFullYear() - 11, new Date().getFullYear()],
    navRange: [new Date().getFullYear() - 11, new Date().getFullYear()]
}
function yearSelectPlugin (pluginConfig) {
    var config = __assign(__assign({}, defaultConfig), pluginConfig)
    return function (fp) {
        fp.config.currentRange = config.currentRange
        fp.config.navRange = config.navRange
        fp.config.dateFormat = config.dateFormat
        fp.config.altFormat = config.altFormat
        fp.config.minDate = config.minDate
        fp.config.maxDate = config.maxDate
        var self = {
            yearsContainer: null
        }
        function clearUnnecessaryDOMElements () {
            if (!fp.rContainer) {
                return
            }
            clearNode(fp.rContainer)
            for (var index = 0; index < fp.monthElements.length; index++) {
                var element = fp.monthElements[index]
                if (!element.parentNode) {
                    continue
                }
                element.parentNode.removeChild(element)
            }
        }
        function build () {
            if (!fp.rContainer) { return }
            fp.currentYearElement.type = 'text'
            self.yearsContainer = fp._createElement('div', 'flatpickr-yearSelect-years')
            self.yearsContainer.tabIndex = -1
            buildYears()
            fp.rContainer.appendChild(self.yearsContainer)
            fp.calendarContainer.classList.add('flatpickr-yearSelect-theme-' + config.theme)
        }
        function buildYears () {
            if (!self.yearsContainer) {
                return
            }
            clearNode(self.yearsContainer)

            var frag = document.createDocumentFragment()
            for (var i = 0; i < 12; i++) {
                var selector = fp.createDay('flatpickr-yearSelect-year', new Date(fp.config.navRange[0] + i, 0), 0, i)
                selector.textContent = selector.dateObj.getFullYear()
                selector.addEventListener('click', selectYear)
                frag.appendChild(selector)
            }
            self.yearsContainer.appendChild(frag)
            if (fp.config.minDate &&
                fp.config.navRange[0] <= fp.config.minDate.getFullYear()
            ) {
                fp.prevMonthNav.classList.add('flatpickr-disabled')
            } else {
                fp.prevMonthNav.classList.remove('flatpickr-disabled')
            }

            if (fp.config.maxDate &&
                fp.config.navRange[1] >= fp.config.maxDate.getFullYear()
            ) {
                fp.nextMonthNav.classList.add('flatpickr-disabled')
            } else {
                fp.nextMonthNav.classList.remove('flatpickr-disabled')
            }
        }
        function bindEvents () {
            fp._bind(fp.prevMonthNav, 'click', function (e) {
                e.preventDefault()
                e.stopPropagation()
                selectYearRange([fp.config.navRange[0] - 12, fp.config.navRange[0]])
                buildYears()
            })
            fp._bind(fp.nextMonthNav, 'click', function (e) {
                e.preventDefault()
                e.stopPropagation()
                selectYearRange([fp.config.navRange[0] + 12, fp.config.navRange[1] + 12])
                buildYears()
            })
        }
        function setCurrentlySelected () {
            if (!fp.rContainer) { return }
            if (!fp.selectedDates.length) { return }
            var currentlySelected = fp.rContainer.querySelectorAll('.flatpickr-yearSelect-year.selected')
            for (var index = 0; index < currentlySelected.length; index++) {
                currentlySelected[index].classList.remove('selected')
            }
        }
        function selectYearRange (range) {
            fp.config.navRange = range
            fp.currentYearElement.value = String(fp.config.navRange[0] + '-' + (fp.config.navRange[1] - 1))
            setCurrentlySelected()
        }
        function selectYear (e) {
            e.preventDefault()
            e.stopPropagation()
            var eventTarget = getEventTarget(e)

            if (!(eventTarget instanceof Element)) { return }
            if (eventTarget.classList.contains('flatpickr-disabled')) { return }
            if (eventTarget.classList.contains('notAllowed')) { }
            setYear(eventTarget.dateObj)
            if (fp.config.closeOnSelect) {
                var single = fp.config.mode === 'single'
                var range = fp.config.mode === 'range' && fp.selectedDates.length === 2
                if (single || range) { fp.close() }
            }
            fp.changeYear(fp.currentYear)
        }
        function setYear (date) {
            var selectedDate = new Date(date.getFullYear(), date.getMonth())
            var selectedDates = []
            switch (fp.config.mode) {
            case 'single':
                selectedDates = [selectedDate]
                break
            case 'multiple':
                selectedDates.push(selectedDate)
                break
            case 'range':
                if (fp.selectedDates.length === 2) {
                    selectedDates = [selectedDate]
                } else {
                    selectedDates = fp.selectedDates.concat([selectedDate])
                    selectedDates.sort(function (a, b) { return a.getTime() - b.getTime() })
                }
                break
            }
            fp.setDate(selectedDates, true)
            setCurrentlySelected()
            fp.config.currentRange = fp.config.navRange.slice()
        }
        function closeHook () {
            var _a
            if (((_a = fp.config) === null || _a === void 0 ? void 0 : _a.mode) === 'range' && fp.selectedDates.length === 1) { fp.clear(false) }
            if (!fp.selectedDates.length) {
                buildYears()
            }
        }
        // Help the prev/next year nav honor config.minDate (see 3fa5a69)
        function stubCurrentYear () {
            config._stubbedCurrentYear = fp._initialDate.getFullYear()
            fp.currentYear = config._stubbedCurrentYear
        }
        function unstubCurrentMonth () {
            if (!config._stubbedCurrentYear) {
                return
            }
            fp._initialDate.setMonth(config._stubbedCurrentYear)
            fp.currentYear = config._stubbedCurrentYear
            delete config._stubbedCurrentYear
        }
        function destroyPluginInstance () {
            if (self.yearsContainer !== null) {
                var years = self.yearsContainer.querySelectorAll('.flatpickr-yearSelect-year')
                for (var index = 0; index < years.length; index++) {
                    years[index].removeEventListener('click', selectYear)
                }
            }
        }
        return {
            onParseConfig: function () {
                // fp.config.enableTime = false
            },
            onValueUpdate: setCurrentlySelected,
            onReady: [
                stubCurrentYear,
                clearUnnecessaryDOMElements,
                build,
                buildYears,
                bindEvents,
                setCurrentlySelected,
                function () {
                    fp.config.onClose.push(closeHook)
                    fp.loadedPlugins.push('yearSelect')
                }
            ],
            onDestroy: [
                unstubCurrentMonth,
                destroyPluginInstance,
                function () {
                    fp.config.onClose = fp.config.onClose.filter(function (hook) {
                        return hook !== closeHook
                    })
                }
            ],
            buildYears
        }
    }
}

export default yearSelectPlugin
